<template>
  <div class="account-page">
    <div class="main-wrapper">
      <layout-header></layout-header>

      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-10 offset-md-1">
              <!-- Login Tab Content -->
              <div class="account-content">
                <div class="row align-items-center justify-content-center">
                  <div class="col-md-7 col-lg-6 login-left">
                    <img
                      src="@/assets/img/Login_banner.png"
                      class="img-fluid"
                      alt="Doccure Login"
                      style="height: 300px;width: 400px;"
                    />
                  </div>
                  <div class="col-md-12 col-lg-5 login-right">
                    <div class="login-header">
                      <h3>Login <span>{{main_data}}</span></h3>
                    </div>
                    <form @submit.prevent="submit_login">
                      <div class="form-group form-focus">
                        <input
                          type="text"
                          v-model="usr"
                          class="form-control floating"
                        />
                        <label class="focus-label"
                          >Enter Your Mobile Number</label
                        >
                      </div>
                      <div class="form-group form-focus">
                        <input
                          :type="isPasswordShow ? 'text' : 'password'"
                          v-model="pwd"
                          class="form-control floating"
                        />
                        <label class="focus-label">Password</label>
                        <img
                          v-if="isPasswordShow"
                          class="visible"
                          src="../../assets/img/icons/visible.svg"
                          @click="isPasswordShow = !isPasswordShow"
                        />
                        <img
                          v-if="!isPasswordShow"
                          width="23px"
                          class="unvisible"
                          src="../../assets/img/icons/unvisible.svg"
                          @click="isPasswordShow = !isPasswordShow"
                        />
                      </div>
                      <div>
                        <router-link class="forgot-link" to="/login"
                          >Login With OTP</router-link
                        >
                        <router-link
                          class="forgot-link"
                          style="margin-left: 196px"
                          to="/forgot-password"
                          >Forgot Password ?</router-link
                        >
                      </div>
                      <button
                        class="btn btn-primary btn-block btn-lg login-btn"
                        type="submit"
                      >
                        Login
                      </button>

                      <div class="text-center dont-have">
                        Don’t have an account?
                        <a @click="navigateToSignup()" href="javascript:void(0)"
                          >Register</a
                        >
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <!-- /Login Tab Content -->
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
  </div>
</template>

<script>
import CommonApi from "../../services/CommonApi";
import { mapGetters, mapActions, mapState } from "vuex";
import axios from "axios";
export default {
  data() {
    return {
      main_data:"",
      usr: "",
      pwd: "",
      isPasswordShow: false,
      config:CommonApi,
    };
  },
  computed: {
    ...mapGetters(["loggedInUser"]),
    ...mapState({
      user: (state) => state.user.user_type,
    }),
  },
  methods: {

    async get_practitioner_profile() {
      var domain = window.location.hostname;

      const formdata = {
        domain: window.location.hostname,
      };
      await axios
        .get(
          "https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        )
        .then((res) => {
          this.showspinner = false;
          if (res.data.status_code == 200) {
            this.main_data = res.data.data[0].brand_name
          }
          if (res.data.status_code == 404) {
            if (window.location.hostname == "physio.sahajhelp.com") {
            } else if (window.location.hostname == "physio.kneexpert.in") {
            } else if (window.location.hostname == "localhost") {
            }
            else if (window.location.hostname.startsWith("192.168")) {
            } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
            } else {
              window.location.href = String("https://physio.kneexpert.in");
            }
          }
          this.$swal.close();
        });
    },

    ...mapActions(["login"]),
    async submit_login() {
      this.$swal({
        text: "Logging in...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      var bodyFormData = new FormData();
      bodyFormData.append("usr", this.usr);
      bodyFormData.append("pwd", this.pwd);
      await CommonApi.post_data(
        "sahaj.login.app_login",
        bodyFormData,
        true
      ).then((res) => {
        if (res.message == "Logged In") {
          var userJson = {
            username: res.full_name,
            user: res.user,
            ...res.key_details,
          };
          if (res.healthcare_id.length) {
            this.$store.dispatch("user/setUserType", "doctor");
            this.$store.dispatch("user/setUserID", res.healthcare_id[0].name);
            userJson.image = res.healthcare_id[0].image;
            userJson.qualification = res.healthcare_id[0].qualification;
          } else {
            this.$store.dispatch("user/setUserType", "patient");
            this.$store.dispatch("user/setUserID", res.patient_id[0].name);
            userJson.image = res.patient_id[0].image;
            userJson.dob = res.patient_id[0].dob;
            userJson.age = res.patient_id[0].age;
            userJson.city = res.patient_id[0].city;
          }
          localStorage.setItem("userInfo", JSON.stringify(userJson));
          if (this.user === "doctor") {
            this.$router.push("/doctor/index");
          } else {
            if (localStorage.getItem("tempPractitioner")) {
              this.$router.push(
                `/patient/booking/${localStorage.getItem("tempPractitioner")}`
              );
              localStorage.removeItem("tempPractitioner");
            } else {
              this.$router.push("/patient/index");
            }
          }
          this.$swal.close();
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res,
            showConfirmButton: true,
          });
        }
      });
    },
    navigateToSignup() {
      this.$router.push("/doctor/register");
    },
  },
};
</script>
<style scoped>
.visible {
  width: 23px;
  position: absolute;
  right: 12px;
  top: 16px;
  cursor: pointer;
}
.unvisible {
  position: absolute;
  right: 12px;
  top: 12px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/kneexpert/Login.vue